import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

import { console } from "#/log";

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: Error) => console.log(err));
